export const ROUTE_GETTING_STARTED_DASHBOARD = "gettingStartedDashboard";
